module.exports = __webpack_public_path__ + "img/agua-color.0181b903.svg";